import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { handleError } from '../../../../../utils';
import { MutationUpdateOrgActivityArgs } from '../../../types';
import { UPDATE_ORG_ACTIVITY } from './updateOrgActivity';

type UpdateOrgActivity = {
  handleUpdateOrgActivity: (orgId: string) => Promise<void>;
  loading: boolean;
};

export const operationOrgActivityName = 'updateOrgActivity';

const useUpdateOrgActivity = (): UpdateOrgActivity => {
  const [updateOrgActivity, { loading }] = useMutation<MutationUpdateOrgActivityArgs>(UPDATE_ORG_ACTIVITY);

  const handleUpdateOrgActivity = useCallback(
    async (orgId: string): Promise<void> => {
      if (orgId) {
        await updateOrgActivity({
          variables: {
            id: orgId,
          },
          onError: handleError,
        });
      }
    },
    [updateOrgActivity]
  );

  return {
    handleUpdateOrgActivity,
    loading,
  };
};

export default useUpdateOrgActivity;
